package com.steamstreet.vegasful.web

import kotlinx.html.FlowContent

/**
 * Class that runs some aspect of a client interaction
 */
interface ClientController {
    /**
     * Start this controller.
     */
    suspend fun run()
}

const val CONTROLLER_ATTRIBUTE = "data-account-module"

sealed class ClientControllerDefinition(val id: String) {
    fun install(content: FlowContent) {
        content.attributes[CONTROLLER_ATTRIBUTE] = id
    }
}

/**
 * Controller definition responsible for sending an 'entity viewed' event.
 */
object EntityViewedController : ClientControllerDefinition("entity-viewed") {
    const val pathAttribute = "data-entity-path"
    fun install(content: FlowContent, entityPath: String) {
        install(content)
        content.attributes[pathAttribute] = entityPath
    }
}